import { atom } from 'jotai';

export const listIsClosedManuallyAtom = atom(false);
